import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import client from '../../lib/feathers';

export default function NewHolidayForm(props) {
  const { onCancelClick, onNewHoliday, onUpdateHoliday, holiday } = props;
  const [name, setName] = useState('');
  const [date, setDate] = useState('');
  const [description, setDescription] = useState('');

  const isEditing = !!holiday;

  useEffect(() => {
    if (holiday) {
      setName(holiday.name || '');
      setDate(holiday.date || '');
      setDescription(holiday.description || '');
    }
  }, [holiday]);

  const onFormSubmit = async (event) => {
    event.preventDefault();
    const service = client.service('admin/holiday');

    if (!name.trim()) {
      toast.error('Please enter a name');
      return;
    }
    if (!date) {
      toast.error('Please select a date');
      return;
    }

    const data = {
      name: name.trim(),
      date,
      description: description.trim() || null,
    };

    try {
      if (isEditing) {
        const result = await service.patch(holiday.id, data);
        onUpdateHoliday(result);
        toast.success(`Updated ${name}`);
      } else {
        const result = await service.create(data);
        onNewHoliday(result);
        toast.success(`Added ${name}`);
      }
    } catch (e) {
      console.error('Error saving holiday:', e);
      toast.error(isEditing ? 'Failed to update holiday' : 'Failed to create holiday');
    }
  };

  return (
    <>
      <div className="mt-3 text-center sm:mt-5">
        <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
          {isEditing ? 'Edit Holiday' : 'Create New Holiday'}
        </h3>
        <div className="mt-2">
          <p className="text-sm text-gray-500">
            {isEditing ? 'Update the holiday details.' : 'Enter the details for this holiday.'}
          </p>
          <form onSubmit={onFormSubmit} className="mt-4">
            <div className="mb-4">
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 text-left">
                Name
              </label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                name="name"
                id="name"
                autoComplete="off"
                placeholder="e.g., Christmas Day"
                className="mt-1 focus:ring-gray-500 focus:border-gray-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              />
            </div>
            <div className="mb-4">
              <label htmlFor="date" className="block text-sm font-medium text-gray-700 text-left">
                Date
              </label>
              <input
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                required
                name="date"
                id="date"
                className="mt-1 focus:ring-gray-500 focus:border-gray-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              />
            </div>
            <div className="mb-4">
              <label htmlFor="description" className="block text-sm font-medium text-gray-700 text-left">
                Description (optional)
              </label>
              <input
                type="text"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                name="description"
                id="description"
                autoComplete="off"
                placeholder="e.g., Federal holiday"
                className="mt-1 focus:ring-gray-500 focus:border-gray-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              />
            </div>
            <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
              <button
                type="submit"
                className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-white hover:bg-red-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:col-start-2 sm:text-sm"
              >
                {isEditing ? 'Save' : 'Create'}
              </button>
              <button
                type="button"
                onClick={onCancelClick}
                className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:mt-0 sm:col-start-1 sm:text-sm"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
